import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const authHeaders = () => {
  const token = localStorage.getItem("bf_admin_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const api = {
  login: async (username, password) => {
    const { data } = await axios.post(`${API}/admin/login`, { username, password });
    return data;
  },
  createBooking: async (payload) => {
    const { data } = await axios.post(`${API}/bookings`, payload);
    return data;
  },
  listBookings: async () => {
    const { data } = await axios.get(`${API}/bookings`, { headers: authHeaders() });
    return data;
  },
  getStats: async () => {
    const { data } = await axios.get(`${API}/bookings/stats`, { headers: authHeaders() });
    return data;
  },
  updateStatus: async (id, status) => {
    const { data } = await axios.patch(`${API}/bookings/${id}`, { status }, { headers: authHeaders() });
    return data;
  },
  deleteBooking: async (id) => {
    const { data } = await axios.delete(`${API}/bookings/${id}`, { headers: authHeaders() });
    return data;
  },
  listServices: async () => {
    const { data } = await axios.get(`${API}/services`);
    return data;
  },
  createService: async (payload) => {
    const { data } = await axios.post(`${API}/services`, payload, { headers: authHeaders() });
    return data;
  },
  updateService: async (id, payload) => {
    const { data } = await axios.put(`${API}/services/${id}`, payload, { headers: authHeaders() });
    return data;
  },
  deleteService: async (id) => {
    const { data } = await axios.delete(`${API}/services/${id}`, { headers: authHeaders() });
    return data;
  },
  // Gallery
  listGallery: async () => (await axios.get(`${API}/gallery`)).data,
  createGallery: async (p) => (await axios.post(`${API}/gallery`, p, { headers: authHeaders() })).data,
  updateGallery: async (id, p) => (await axios.put(`${API}/gallery/${id}`, p, { headers: authHeaders() })).data,
  deleteGallery: async (id) => (await axios.delete(`${API}/gallery/${id}`, { headers: authHeaders() })).data,
  // Testimonials
  listTestimonials: async () => (await axios.get(`${API}/testimonials`)).data,
  createTestimonial: async (p) => (await axios.post(`${API}/testimonials`, p, { headers: authHeaders() })).data,
  updateTestimonial: async (id, p) => (await axios.put(`${API}/testimonials/${id}`, p, { headers: authHeaders() })).data,
  deleteTestimonial: async (id) => (await axios.delete(`${API}/testimonials/${id}`, { headers: authHeaders() })).data,
  // Content
  getContent: async () => (await axios.get(`${API}/content`)).data,
  updateContent: async (values) => (await axios.put(`${API}/content`, { values }, { headers: authHeaders() })).data,
  // Team (Factory Team Experience)
  listTeam: async () => (await axios.get(`${API}/team`)).data,
  createTeam: async (p) => (await axios.post(`${API}/team`, p, { headers: authHeaders() })).data,
  updateTeam: async (id, p) => (await axios.put(`${API}/team/${id}`, p, { headers: authHeaders() })).data,
  deleteTeam: async (id) => (await axios.delete(`${API}/team/${id}`, { headers: authHeaders() })).data,
  // Upload -> returns absolute url
  uploadImage: async (file) => {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await axios.post(`${API}/upload`, fd, {
      headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
    });
    return `${BACKEND_URL}${data.url}`;
  },
};

export { BACKEND_URL };

export default api;
